/* eslint-disable react/display-name */
import type { ReactElement } from "react"

import { motion } from "framer-motion"

import { EWaveLoaderVariant, WaveLoader } from "@/3514/components"

export default (): ReactElement => (
    <motion.div
        initial={{ scale: 0.9, opacity: 0.9 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0.9 }}
        layout
        layoutId="attendance-modal-loader"
        transition={{ duration: 0.3 }}
        style={{ minHeight: "100px", display: "flex" }}
    >
        <WaveLoader cssIdentifier="root-loader" withRelativePosition variant={EWaveLoaderVariant.LightBlue} />
    </motion.div>
)
